import { render, staticRenderFns } from "./AdvisorsTable.vue?vue&type=template&id=ffa6facc&"
import script from "./AdvisorsTable.vue?vue&type=script&lang=js&"
export * from "./AdvisorsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorsTable.vue?vue&type=style&index=0&id=ffa6facc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports